import NamedCourseList from "./NamedCourseList";
import SongCategory from "./SongCategory";
import IFeaturedBootcampLesson from "./IFeaturedBootcampLesson";

export default class MyLibraryResponse {
  courseSections: NamedCourseList[];
  songCategories: SongCategory[];
  featuredBootcampLesson: IFeaturedBootcampLesson;
  constructor({courseSections, songCategories, featuredBootcampLesson}: MyLibraryResponse) {
    Object.assign(this, {courseSections, songCategories, featuredBootcampLesson});
  }
}